import { LOGIN, LOGOUT, USER_LOADED, USER_LOADING, AUTH_ERROR } from '../actions/types';


const initialState = {
    token:localStorage.getItem('token'),
    isLoading:false,
    isLoggedIn:false,
    user:null,
}

export default function(state = initialState, action){
    switch(action.type){
        case LOGIN:
            localStorage.setItem('token', action.payload.token)
            return {
                ...state,
                isLoggedIn:true,
                isLoading:false,
                user:action.payload.user,
                token:action.payload.token,
            }
        case LOGOUT:
            localStorage.removeItem('token')
            return {
                ...state,
                isLoggedIn:false,
                user:null,
                token:null
            }
        case USER_LOADING:
            return{
                ...state,
                isLoading:true,
            }
        case USER_LOADED:
            return{
                ...state,
                isLoggedIn:true,
                isLoading:false,
                user:action.payload.user
            }
        case AUTH_ERROR:
            localStorage.removeItem('token')
            return{
                ...state,
                token:null,
                isLoggedIn:false,
                isLoading:false,
                user:null
            }
        default:
            return state;
    }
}
  